import React, { useEffect, useState } from "react";
import "./style.scss";
import Button from "../../../common/Button";
const ChangeAngleView = ({ activeAngle, anglesList, markAngleChangeDone }) => {
  const [filterList, setFilterList] = useState([]);
  const [activeFilter, setActiveFilter] = useState(0);
  const [updatedAngle, setUpdatedAngle] = useState(activeAngle);
  const [updatedAngleImage, setUpdatedAngleImage] = useState("");
  const [updatedImageData, setUpdatedImageData] = useState();
  useEffect(() => {
    const filtered = anglesList.filter((x, id) => {
      return id === activeFilter;
    });
    setFilterList(filtered);
  }, [activeFilter, anglesList]);

  const handleChangeAngle = (angleId, angleImage, image) => {
    setUpdatedAngle(angleId);
    setUpdatedAngleImage(angleImage);
    setUpdatedImageData(image);
  };

  return (
    <div className="change_angle_view_wrapper">
      <div className="change_angle_view_content">
        <div className="action_container">
          <div className="filter_wrapper">
            {anglesList.map((filter, index) => {
              return (
                <button
                  className={
                    index === activeFilter ? "button_active" : "button_inactive"
                  }
                  onClick={() => {
                    setActiveFilter(index);
                    // handleFilter(index);
                  }}
                  key={index}
                >
                  {filter.shootType}
                </button>
              );
            })}
          </div>
          <div className="submit_wrapper">
            <Button
              width="90px"
              height="40px"
              text="Done"
              isDisabled={activeAngle === updatedAngle}
              handleClick={() =>
                markAngleChangeDone(
                  updatedAngle,
                  updatedAngleImage,
                  updatedImageData
                )
              }
            />
          </div>
        </div>
        <div className="list_container">
          <div className="content">
            {filterList[0]?.angles.map((image, id) => {
              return (
                <div className="content_image" key={id}>
                  <div
                    className={`image_wrapper ${
                      updatedAngle === image._id ? "active_angle" : ""
                    }`}
                    onClick={() =>
                      handleChangeAngle(
                        image._id,
                        image?.image?.thumbPath?.url,
                        image
                      )
                    }
                  >
                    <img src={image?.image?.thumbPath?.url} alt={image.name} />
                  </div>
                  <span>{image.name}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
export default ChangeAngleView;
